"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Returns the value of the specified path
function get(obj, path, defaultValue) {
    var _a;
    if (!path) {
        return defaultValue;
    }
    var keys = "".concat(path).split('.');
    if (!obj) {
        return defaultValue;
    }
    // Return value if it's the last key
    if (keys.length === 1) {
        return (_a = obj === null || obj === void 0 ? void 0 : obj[keys[0]]) !== null && _a !== void 0 ? _a : defaultValue;
    }
    // Repeat until there is only one key left
    var key = keys[0], rest = keys.slice(1);
    return get(obj === null || obj === void 0 ? void 0 : obj[key], rest.join('.'), defaultValue);
}
exports.default = get;
